import { ModalClose } from "../modalToggle";
import { SortSet, CheckNone } from "./sort";
const sortName: string = "c-room__sort__modal__text";
const activeName: string = "c-room__sort__modal__text--active";
const inputValue: string = "js-room-sort-value";
const sortValue: HTMLElement = document.querySelector(".js-room-sort")!;

document.addEventListener("click", ( event: any ) => {
  const sortButton: HTMLElement = event.target.closest(`.${sortName}`)!;
  if (sortButton) {
    const active: HTMLElement = document.querySelector(`.${activeName}`)!;
    const valueElm: HTMLElement = sortButton.querySelector(`.${inputValue}`)!;
    const value: string = valueElm.innerText!;
    const dataValue: string = valueElm.dataset.status!;
    console.log(value);
    active.classList.remove(activeName);
    setTimeout(() => {
      sortButton.classList.add(activeName);
      sortValue.innerText = value;
      ModalClose();
      SortSet(dataValue);
      CheckNone(dataValue);
    },200);
  }
})

window.addEventListener("load", () => {
  CheckNone("");
})
